import { defineMessages } from 'react-intl-next';

export const i18n: {
    searchClearFilterLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    };
} = defineMessages({
	searchClearFilterLabel: {
		id: 'search-page.filter.clear.filter.label',
		defaultMessage: 'Clear filter',
		description: 'Label for button to clear filter options',
	},
});
